import React, {useEffect, useRef} from 'react';
import { useSettings } from '../context/SettingsContext';
import ToggleSlider from './ToggleSlider';
import '../styles/SettingsModal.css';

const SettingsModal = ({ onClose }) => {
    const { settings, toggleSetting } = useSettings();
    const modalContentRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalContentRef.current && !modalContentRef.current.contains(event.target)) {
                onClose(); // Die übergebene onClose Funktion aufrufen
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);

    return (
        <div className="settings-backdrop">
            <div className="settings-modal" ref={modalContentRef}>
                <button className="settings-close-button" onClick={onClose}>
                    <i className="fas fa-times"></i>
                </button>
                <h2>Einstellungen</h2>

                <div className="settings-section">
                    <h3>Anzeigeoptionen</h3>
                    <ToggleSlider
                        checked={settings.particlesEnabled}
                        onChange={() => toggleSetting('particlesEnabled')}
                        label="Partikel anzeigen"
                    />
                    <ToggleSlider
                        checked={settings.fpsDisplayEnabled}
                        onChange={() => toggleSetting('fpsDisplayEnabled')}
                        label="FPS anzeigen"
                    />
                </div>

            </div>
        </div>

    );
};

export default SettingsModal;
